import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.svg';

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 50px;
  height: 100px;
  background-color: var(--dark-navy);
`;

const StyledNav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ol {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      margin: 0 10px;
      font-family: var(--font-mono);
      font-size: 14px;

      a {
        padding: 10px;
        color: var(--lightest-slate);
        text-decoration: none;
        transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:hover {
          color: var(--cyan);
        }
      }
    }
  }
`;

const Header = () => (
  <StyledHeader>
    <div>
      <img src={logo} alt="logo" style={{ width: '50px', height: '50px' }} />
    </div>
    <StyledNav>
      <ol>
        <li><a href="#about">About</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Our Work</a></li>
        <li><a href="#contact">Contact</a></li>
      </ol>
    </StyledNav>
  </StyledHeader>
);

export default Header;